import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { BillingPlanTier } from '@recruitee/products-types';
import { PlanButtonComponent } from '@recruitee/user-interface';

@Component({
  standalone: true,
  imports: [PlanButtonComponent],
  selector: 'rt-feature-button',
  template: `<rt-plan-button
    [hasIcon]="hasIcon"
    [variant]="buttonVariant"
    (click)="openPlanPicker.emit()"
    class="default"
    ><ng-content></ng-content
  ></rt-plan-button>`,
  styleUrls: ['./feature-button.component.less'],
  host: {
    '[class]': '"plan-"+ plan',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeatureButtonComponent {
  @Input() public plan: BillingPlanTier | null;
  @Output() public openPlanPicker: EventEmitter<void> = new EventEmitter<void>();

  public BillingPlanTier: typeof BillingPlanTier = BillingPlanTier;

  public get buttonVariant() {
    switch (this.plan) {
      case BillingPlanTier.Lead:
      case BillingPlanTier.Scale:
      case BillingPlanTier.Grow:
      case BillingPlanTier.Optimize:
        return this.plan;
      default:
        return 'tertiary';
    }
  }

  public get hasIcon(): boolean {
    return !!this.plan && [BillingPlanTier.Scale, BillingPlanTier.Lead].includes(this.plan);
  }
}
